module.exports = __webpack_public_path__ + "img/shuzibig.1b01cbc5.gif";